/**
 * comment.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { AbstractControl } from "@angular/forms";
import { TypedData } from "../common/data/typed-data";

export enum CommentType
{
  SubjectContext,
  IntakeStep
}

export enum Visibility {
  Public,
  GroupOnly,
  SelfOnly
}

export class Comment
{
  public commentId : number;
  public creator : string;
  public org : string;
  public groupIds : number[];
  public created : number;
  public updated : number;
  public comment : string;
  public editable : boolean = false;
  public editing : boolean = false;
  public public : boolean = false;

  public visControl? : AbstractControl;

  public get typedCreated () : TypedData
  {
    return new TypedData("datetime", new Date(+this.created));
  }
  public get typedUpdated () : TypedData
  {
    return new TypedData("datetime", new Date(+this.updated));
  }

  public static fromData (existing : Comment) : Comment
  {
    const comment : Comment = new Comment();
    // TODO: check here!
    return Object.assign(comment, existing);
  }

  public static applyVisibilityToMessage (
    msg : any,
    visibility : Visibility,
    groupIds : number[]
  ) : void
  {
    if (visibility !== Visibility.SelfOnly)
    {
      msg.isPublic = (visibility === Visibility.Public);
      msg.groupIds = groupIds;
      console.log("visibility", visibility, (typeof visibility));
      console.log("public?", msg.isPublic);
    }
    else
    {
      msg.isPublic = false;
      msg.groupIds = [];
    }
  }

  public static visibilityOf (comment : Comment) : Visibility
  {
    if (comment.groupIds.length === 0)
    {
      return Visibility.SelfOnly;
    }
    return comment.public ? Visibility.Public : Visibility.GroupOnly;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/intake-form/comment.ts